var React = require('react');

function Bag (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18.667 7.00015C18.667 10.0596 15.7081 12.8336 11.6668 12.8336C7.62556 12.8336 4.66669 10.0596 4.66669 7.00015C4.66669 3.94067 7.62556 1.16669 11.6668 1.16669C15.7081 1.16669 18.667 3.94067 18.667 7.00015Z","stroke":"currentColor","strokeWidth":"2.33338","key":0}),React.createElement("rect",{"x":"1.16669","y":"7.00019","width":"21.0004","height":"19.8338","fill":"white","stroke":"currentColor","strokeWidth":"2.33338","key":1})]);
}

Bag.defaultProps = {"width":"24","height":"28","viewBox":"0 0 24 28","fill":"none"};

module.exports = Bag;

Bag.default = Bag;
